var React = require('react');

function IconBorderedSuccess (props) {
    return React.createElement("svg",props,[React.createElement("polyline",{"fill":"none","stroke":"#F54B26","strokeWidth":"2","points":"35.2,1 1,1 1,50 50,50 50,17.3 ","key":0}),React.createElement("rect",{"fill":"#F54B26","x":"2","y":"47","width":"48","height":"3","key":1}),React.createElement("polyline",{"fill":"none","stroke":"#F54B26","strokeWidth":"5","points":"15,25.1 23.9,34 38,17 ","key":2})]);
}

IconBorderedSuccess.defaultProps = {"width":"51px","height":"51px","viewBox":"0 0 51 51"};

module.exports = IconBorderedSuccess;

IconBorderedSuccess.default = IconBorderedSuccess;
